import HTMLObject from '../misc/html/html.object';
import * as THREE from 'three';

export class HTMLLabel extends HTMLObject {

  static PADDING = 5;

  static types = {
    align: {
      LEFT: 'left',
      CENTER: 'center',
      RIGHT: 'right'
    },
    verticalAlign: {
      CENTER: 'center',
      BOTTOM: 'bottom'
    },
    // axis: {
    //   X: 'x',
    //   Y: 'y',
    //   Z: 'z'
    // },
    // dimension: {
    //   WIDTH: 'width',
    //   HEIGHT: 'height'
    // },
    // padding: {
    //   ADDHALF: 'addhalf',
    //   REMOVEHALF: 'removehalf',
    //   ADDFULL: 'full',
    //   REMOVEFULL: 'removefull'
    // }
  };

  constructor({ text, align, verticalAlign, color, bold }) {
    super();

    this.align = align;
    this.verticalAlign = verticalAlign;

    // TODO: Refactoring
    this.domElement.style.position = 'absolute';
    // prevent collision between draggable objects and html objects
    this.domElement.style.pointerEvents = "none";

    this.textElement = document.createElement('p');
    this.textElement.className = 'label__text';
    // this.textElement.style.position = 'relative';
    this.textElement.style.margin = '0';
    this.textElement.style.userSelect = 'none';
    this.textElement.style.whiteSpace = 'nowrap';
    this.textElement.style.color = color;
    if(bold === true)
      this.textElement.style.fontWeight = 'bold';

    this.domElement.appendChild(this.textElement);

    this.text = text;
  }

  get text() {
    return this._text;
  }

  set text(value) {
    this._text = value;
    this.textElement.innerHTML = this._text;
  }

  render(camera, renderer) {
    super.render(camera, renderer);

    const pos = {
      x: parseFloat(this.domElement.style.left),
      y: parseFloat(this.domElement.style.top)
    };

    let elemWidth;
    let elemHeight;

    if (this.rotationDegrees) {
      var transform = this.domElement.style.transform;
      this.domElement.style.transform = "none";
      elemWidth = this.getElementRect().width;
      elemHeight = this.getElementRect().height;
      this.domElement.style.transform = transform;
    } else {
      elemWidth = this.getElementRect().width;
      elemHeight = this.getElementRect().height;
    }

    switch (this.align) {
      case HTMLEditableLabel.types.align.CENTER: {
        pos.x -= elemWidth / 2;

        break;
      }
      case HTMLEditableLabel.types.align.RIGHT: {
        pos.x -= elemWidth + HTMLLabel.PADDING * camera.zoom;

        break;
      }
      case HTMLEditableLabel.types.align.LEFT: 
      default: {
        pos.x += HTMLLabel.PADDING * camera.zoom;
        break;
      }
    }

    switch (this.verticalAlign) {
      case HTMLEditableLabel.types.verticalAlign.BOTTOM: {
        pos.y -= elemHeight;

        break;
      }
      case HTMLEditableLabel.types.verticalAlign.CENTER: {
        pos.y -= elemHeight / 2;

        break;
      }
      default: {
        break;
      }
    }

    if (this.state === HTMLEditableLabel.states.INPUT) {
      let rendererSize = new THREE.Vector2();
      renderer.getSize(rendererSize);
      if (pos.x < 0)
        pos.x = 0;
      else if (rendererSize.width < pos.x + elemWidth)
        pos.x = rendererSize.width - elemWidth;

      if (pos.y < 0)
        pos.y = 0;
      else if (rendererSize.height < pos.y + elemHeight)
        pos.y = rendererSize.height - elemHeight;
    }
    this.domElement.style.left = `${pos.x}px`;
    this.domElement.style.top = `${pos.y}px`;
  }

  get textLabelWidth() {
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    context.font = this.textElement.style.font;
    var metrics = context.measureText(this.text);

      return metrics.width * 1.1;
  }

  // addDynamicPadding(axis, dimension, value) {
  //   if (!this.dynamicPadding)
  //     this.dynamicPadding = [];
    
  //   this.dynamicPadding.push({ axis, dimension, value});
  // }

  // applyDynamicPadding(position, camera, renderer) {
  //   if (this.dynamicPadding) {
  //     let crtPadding, crtValue;
  //     for (let i = 0; i < this.dynamicPadding.length; i++) {
  //       crtPadding = this.dynamicPadding[i];

  //       if (crtPadding.dimension === HTMLLabel.types.dimension.WIDTH)
  //         crtValue = this.getElementRect().width;
  //       else if (crtPadding.dimension === HTMLLabel.types.dimension.HEIGHT)
  //         crtValue = this.getElementRect().height;

  //       if (crtPadding.value === HTMLLabel.types.padding.REMOVEHALF || crtPadding.value === HTMLLabel.types.padding.REMOVEFULL)
  //         crtValue *= -1;
  //       if (crtPadding.value === HTMLLabel.types.padding.ADDHALF || crtPadding.value === HTMLLabel.types.padding.REMOVEHALF)
  //         crtValue /= 2;
        
  //       switch (crtPadding.axis) {
  //         case HTMLLabel.types.axis.X: { position.x += crtValue; break; }
  //         case HTMLLabel.types.axis.Y: { position.y += crtValue; break; }
  //         case HTMLLabel.types.axis.Z: { position.z += crtValue; break; }
        
  //         default:
  //           break;
  //       }
  //     }
  //   }
  // }

}

/* eslint-disable */
export class HTMLEditableLabel extends HTMLLabel {

  static states = {
    LABEL: 'label',
    INPUT: 'input'
  }

  constructor({ text, value, color, align, verticalAlign, bold, minValue, maxValue, initialState }) {
    if (value === undefined) throw new TypeError('Value is required!');

    super({ text, align, verticalAlign, color, bold });
    this.domElement.style.pointerEvents = "";

    this.input = document.createElement('input');
    this.input.className = 'label__input';
    this.input.style.display = 'none';
    this.input.style.overflow = 'hidden';
    this.input.type = 'number';
    this.input.step = '1';
    this.input.lang = "fr";

    this.domElement.appendChild(this.input);

    this.domElement.addEventListener('click', this.onClick.bind(this));

    this.value = value;
    this.minValue = minValue;
    this.maxValue = maxValue;

    this.state = initialState || HTMLEditableLabel.states.LABEL;
    if (this.state === HTMLEditableLabel.states.INPUT)
      setTimeout(() => { this.onEditMode(); }); // switch to edit mode after the DOM is rendered
  }

  get value() {
    return this._value;
  }

  set value(value) {
    this._value = value;
    this.input.value = this._value;
  }

  onClick() {
    // VladP: Prevent additional event listeners (can click on the input while in EditMode)
    if (this.input.style.display === 'none')
      this.onEditMode();
  }

  onEditMode() {
    // const elementSize = this.getElementRect();
    // VladP: Set the same size as the label (but prevent the width being too small and also add extra width for the step arrows)
    let width = Math.max(this.textElement.clientWidth, 50) + 25;
    this.input.style.width = `${width}px`;
    this.input.style.height = `${this.textElement.clientHeight}px`;
    this.input.style.display = 'block';
    this.domElement.style.zIndex = '10001'; // html layer is set to 10000; this will prevent other texts to overlap the input
    this.domElement.style.left = '0px'; // do a reset to prevent moving the entire html layer when the label is clipped by the canvas
    this.input.focus();
    
    this.textElement.style.display = 'none';
    this.allowRotation = false;
    this.allowScaling = false;
    this.state = HTMLEditableLabel.states.INPUT;

    document.addEventListener('mousedown', this.onOutsideClick.bind(this));
  }

  offEditMode() {
    this.input.style.display = 'none';
    this.textElement.style.display = 'block';
    this.allowRotation = true;
    this.allowScaling = true;
    this.state = HTMLEditableLabel.states.LABEL;
  }

  onInputChange(callback) {
    this.input.addEventListener('blur', () => {
      // this.input.value = this.input.value.replace(',', '.');
      if ((this.minValue !== undefined && +this.input.value < this.minValue) || 
        (this.maxValue !== undefined && +this.input.value > this.maxValue)) {
          this.input.value = this.value;
      }
      else if (callback) callback(this.input.value.trim(), +this.input.value.trim() !== +this.value);
      this.offEditMode();
    });

    this.input.addEventListener('keydown', (e) => {
      const escape = 27;
      const enter = 13;

      if (e.keyCode === enter) {
        this.input.blur();
      }

      if (e.keyCode === escape) {
        this.input.value = this.value;
        this.offEditMode();
      }
    });
  }

  onOutsideClick(e) {
    if (!this.input.contains(e.target)) {
      this.input.blur();
      document.removeEventListener('click', this.onOutsideClick.bind(this));
    }
  }

  onLabelClick(callback) {
    if (callback) {
      this.textElement.addEventListener('click', (args) => {
        callback();
      });
    }
  }

}





// WEBPACK FOOTER //
// ./src/object-view/objects/html-label.js